import { render, staticRenderFns } from "./PurchaseOrderTableForm.vue?vue&type=template&id=c2cc89de&scoped=true&"
import script from "./PurchaseOrderTableForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderTableForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderTableForm.vue?vue&type=style&index=0&id=c2cc89de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cc89de",
  null
  
)

export default component.exports